<script setup>
import LineChart from '@js/components/charts/LineChart.vue';
import SmallLineChart from '@js/components/charts/SmallLineChart.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';

const {
    labels,
    datasets,
    title,
    withDecimalsAxis1 = true,
    axis1BeginAtZero = false,
    reverseAxis1 = false,
    minAxis1 = null,
    maxAxis1 = null,
} = defineProps({
    labels: {
        type: Array,
        required: true,
    },
    datasets: {
        type: Array,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    withDecimalsAxis1: {
        type: Boolean,
        required: false,
    },
    axis1BeginAtZero: {
        type: Boolean,
        required: false,
    },
    reverseAxis1: {
        type: Boolean,
        required: false,
    },
    minAxis1: {
        type: Number,
        required: false,
    },
    maxAxis1: {
        type: Number,
        required: false,
    },
});
</script>

<template>
    <DialogModal size="large">
        <template #trigger>
            <slot v-if="$slots.trigger" name="trigger" />

            <button v-else type="button">
                <SmallLineChart
                    :labels="labels"
                    :datasets="datasets"
                    :axis1-begin-at-zero="axis1BeginAtZero"
                    :reverse-axis1="reverseAxis1"
                    :min-axis1="minAxis1"
                    :max-axis1="maxAxis1"
                />
            </button>
        </template>

        <template #title>
            {{ title }}
        </template>

        <template #content>
            <LineChart
                :labels="labels"
                :datasets="datasets"
                :with-decimals-axis1="withDecimalsAxis1"
                :axis1-begin-at-zero="axis1BeginAtZero"
                :reverse-axis1="reverseAxis1"
                :min-axis1="minAxis1"
                :max-axis1="maxAxis1"
            />
        </template>
    </DialogModal>
</template>
